export const MASK_VERSION = 2;
export const DESIGN_MIN_SIZE = 400;
